import { AlertRule } from "@/models/AlertRule";

export default function evaluateAlertCondition(
  rule: AlertRule,
  value: number | null,
  previousValue?: number | null,
): boolean {
  if (value === null || value === undefined) return false;

  switch (rule.conditionType) {
    case "above":
      return rule.threshold !== undefined && value > rule.threshold;
    case "below":
      return rule.threshold !== undefined && value < rule.threshold;
    case "between":
      return rule.thresholdMin !== undefined && rule.thresholdMax !== undefined &&
        value >= rule.thresholdMin && value <= rule.thresholdMax;
    case "outside":
      return rule.thresholdMin !== undefined && rule.thresholdMax !== undefined &&
        (value < rule.thresholdMin || value > rule.thresholdMax);
    case "equals":
      return rule.threshold !== undefined && value === rule.threshold;
    case "changes":
      return previousValue !== undefined && previousValue !== null && value !== previousValue;
    default:
      return false;
  }
}
